export default "__VITE_ASSET__aeafcfc2__"